import Api from '../api';

import User from './model';
import { storeAction } from './actions';

export default class UserApi {
  static fetch() {
    return Api.get('api/users/me').map((user) => storeAction(new User(user)));
  }

  static update(data) {
    return Api.patch('api/users/me', data).map((user) =>
      storeAction(new User(user), Object.keys(data))
    );
  }

  static password(data) {
    return Api.put('api/users/me/password', data);
  }

  static createOrganizer(user, type = 'nonprofit') {
    return Api.post(`api/users/createOrganizer/${type}`, user);
  }

  static createOrganizerClaimingNonprofit(user) {
    return Api.post(`api/users/nonprofit`, user);
  }

  static requestResetPassword(email) {
    return Api.post('api/users/resetPassword', { email, type: 'Organizer' });
  }

  static resetPassword(token, password) {
    return Api.post(`api/users/resetPassword/${token}`, { password });
  }

  static unblockOrganizer(token) {
    return Api.post(`api/users/verify/organizer/${token}`);
  }

  static search(term) {
    return Api.post('api/users/search', { term });
  }

  static myCurrency() {
    return Api.get('api/users/myCurrency');
  }

  static impersonate(userId, impersonationReason) {
    return Api.post(`api/users/impersonate/${userId}`, { impersonationReason });
  }
}
